import i18n from "../../i18n";
import axios from "axios";

const actions = {
  getSettingData(context, name) {
    return axios
      .get("settings/" + name)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  setSettingData(context, item) {
    return axios
      .put("settings/" + item.id, item)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.settingUpdated"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  getNotificationSubscribers(context) {
    return axios
      .get("settings/notificationSubscribers")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        return null;
      });
  },
  setNotificationSubscribers(context, value) {
    return axios
      .put("settings/notificationSubscribers", { value })
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.saved"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  getProofers(context) {
    return axios
      .get("settings/proofers")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return null;
      });
  },
  setProofers(context, value) {
    return axios
      .put("settings/proofers", { value })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
